import { formClient } from '@/api/client'

declare let ANAPI_TOKEN: string

export async function saveLogo(file, id, type = 'logo') {
    const formData = new FormData()
    formData.append('files[]', file)
    formData.append('_token', ANAPI_TOKEN)

    return formClient.post(`/setting/email/savelogo/${id}/${type}`, formData)
}
